import { axiosAssessmentInstance, axiosArisChatInstance } from "../AxiosConfiguration";

export const getElements = async () => {
  try {
    const response = await axiosAssessmentInstance.post(`/api/v2/assessment/elements`, {
      create: 0,
    });
    return response?.data;
  } catch (error) {
    console.error("Error during API call:", error);
    return error;
  }
};

export const generateElementsSummary = async () => {
  try {
    const res = await axiosArisChatInstance.post(`/ARIS/v2/elements/summary/generate`);
    return res?.data;
  } catch (error) {
    console.error("Error generating elements summaries:", error);
    throw error;
  }
};

export const getElementsSummaryV3 = async () => {
  try {
    const res = await axiosArisChatInstance.get(`/ARIS/v3/elements/summary`);
    return res?.data?.data || null;
  } catch (error) {
    console.error("Error fetching v3 elements summary:", error);
    throw error;
  }
};

export const getShowingUpRecently = async (elementKey) => {
  if (!elementKey) return null;
  try {
    const res = await axiosArisChatInstance.get(
      `/ARIS/v2/elements/cards/${encodeURIComponent(elementKey)}/showing-up-recently`
    );
    return res?.data?.payload || res?.data?.data || null;
  } catch (error) {
    console.error("Error fetching showing-up-recently card:", error);
    return null;
  }
};

export const getTryDifferentApproach = async (elementKey) => {
  if (!elementKey) return null;
  try {
    const res = await axiosArisChatInstance.get(
      `/ARIS/v2/elements/cards/${encodeURIComponent(elementKey)}/try-different-approach`
    );
    return res?.data?.payload || res?.data?.data || null;
  } catch (error) {
    console.error("Error fetching try-different-approach card:", error);
    return null;
  }
};
